import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './solvegame.css';
import trueSound from './assets/true.wav';
import wrongSound from './assets/wrong.wav';
import solveSound from './assets/Solve-Sound.wav';
import countdownSound from './assets/Countdown-120s.wav';
import Swal from 'sweetalert2';
import { db } from '../Firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

// ตั้งค่า SweetAlert2 ให้แสดงค้างไว้
const Toast = Swal.mixin({
  showConfirmButton: true,
  showDenyButton: false,
  showCancelButton: false,
  showCloseButton: false,
  allowOutsideClick: false,
  allowEscapeKey: false,
  timer: undefined,
  timerProgressBar: false,
  backdrop: true,
  heightAuto: false
});

function SolveGame({ userData, onUserUpdate, visible, onClose }) {
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const inputRef = useRef(null);

  // Auto-focus logic moved below state definitions
 
  // ข้อมูลภาพโจทย์และคำตอบทั้งหมด 21 ข้อ
  const problemSets = [
    { id: 0, image: require('./assets/solve-0.jpg'), answer: '5' },
    { id: 1, image: require('./assets/solve-1.jpg'), answer: '8' },
    { id: 2, image: require('./assets/solve-2.jpg'), answer: '9' },
    { id: 3, image: require('./assets/solve-3.jpg'), answer: '16' },
    { id: 4, image: require('./assets/solve-4.jpg'), answer: '11' },
    { id: 5, image: require('./assets/solve-5.jpg'), answer: '8' },
    { id: 6, image: require('./assets/solve-6.jpg'), answer: '6' },
    { id: 7, image: require('./assets/solve-7.jpg'), answer: '10' },
    { id: 8, image: require('./assets/solve-8.jpg'), answer: '42' },
    { id: 9, image: require('./assets/solve-9.jpg'), answer: '5' },
    { id: 10, image: require('./assets/solve-10.jpg'), answer: '33' },
    { id: 11, image: require('./assets/solve-11.jpg'), answer: '79' },
    { id: 12, image: require('./assets/solve-12.jpg'), answer: '60' },
    { id: 13, image: require('./assets/solve-13.jpg'), answer: '35' },
    { id: 14, image: require('./assets/solve-14.jpg'), answer: '29' },
    { id: 15, image: require('./assets/solve-15.jpg'), answer: '4' },
    { id: 16, image: require('./assets/solve-16.jpg'), answer: '8' },
    { id: 17, image: require('./assets/solve-17.jpg'), answer: '22' },
    { id: 18, image: require('./assets/solve-18.jpg'), answer: '7' },
    { id: 19, image: require('./assets/solve-19.jpg'), answer: '10' },
    { id: 20, image: require('./assets/solve-20.jpg'), answer: '6' },
    { id: 21, image: require('./assets/solve-21.jpg'), answer: '33' },
    { id: 22, image: require('./assets/solve-22.jpg'), answer: '14' },
    { id: 23, image: require('./assets/solve-23.jpg'), answer: '13' },
    { id: 24, image: require('./assets/solve-24.jpg'), answer: '19' },
    { id: 25, image: require('./assets/solve-25.jpg'), answer: '9' },
    { id: 26, image: require('./assets/solve-26.jpg'), answer: '2' },
    { id: 27, image: require('./assets/solve-27.jpg'), answer: '8' },
    { id: 28, image: require('./assets/solve-28.jpg'), answer: '4' },
    { id: 29, image: require('./assets/solve-29.jpg'), answer: '31' },
    { id: 30, image: require('./assets/solve-30.jpg'), answer: '16' },
    { id: 31, image: require('./assets/solve-31.jpg'), answer: '20' },
    { id: 32, image: require('./assets/solve-32.jpg'), answer: '40' },
    { id: 33, image: require('./assets/solve-33.jpg'), answer: '21' },
    { id: 34, image: require('./assets/solve-34.jpg'), answer: '24' },
    { id: 35, image: require('./assets/solve-35.jpg'), answer: '15' },
    { id: 36, image: require('./assets/solve-36.jpg'), answer: '11' },
    { id: 37, image: require('./assets/solve-37.jpg'), answer: '10' },
    { id: 38, image: require('./assets/solve-38.jpg'), answer: '13' },
    { id: 39, image: require('./assets/solve-39.jpg'), answer: '5' },
    { id: 40, image: require('./assets/solve-40.jpg'), answer: '35' },
    { id: 41, image: require('./assets/solve-41.jpg'), answer: '13' },
    { id: 42, image: require('./assets/solve-42.jpg'), answer: '15' },
    { id: 43, image: require('./assets/solve-43.jpg'), answer: '22' },
    { id: 44, image: require('./assets/solve-44.jpg'), answer: '15' },
    { id: 45, image: require('./assets/solve-45.jpg'), answer: '26' },
    { id: 46, image: require('./assets/solve-46.jpg'), answer: '20' },
    { id: 47, image: require('./assets/solve-47.jpg'), answer: '40' },
    { id: 48, image: require('./assets/solve-48.jpg'), answer: '3' },
    { id: 49, image: require('./assets/solve-49.jpg'), answer: '6' }
  ];  

  const [currentProblem, setCurrentProblem] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [score, setScore] = useState(0);
  const [gameStarted, setGameStarted] = useState(false);
  const [timeLeft, setTimeLeft] = useState(120);
  const [gameEnded, setGameEnded] = useState(false);
  const [currentLevel, setCurrentLevel] = useState(0);
  const [infoShown, setInfoShown] = useState(false);

  // Auto-focus input when game starts
  useEffect(() => {
    if (gameStarted && inputRef.current) {
        setTimeout(() => {
            inputRef.current?.focus();
        }, 100);
    }
  }, [gameStarted]);

  // Function to safely stop audio
  const stopAudio = () => {
    if (audioRef.current) {
      try {
        // หยุดการเล่นแบบ loop ก่อน
        audioRef.current.loop = false;
        // หยุดเสียง
        audioRef.current.pause();
        // รีเซ็ตเวลา
        audioRef.current.currentTime = 0;
        // ล้าง event listeners
        audioRef.current.onended = null;
        audioRef.current.onerror = null;
        // ล้าง reference
        audioRef.current = null;
        setIsAudioPlaying(false);
      } catch (error) {
      }
    } else {
    }
  };

  // Function to safely play audio
  const playAudio = async (audioSrc, loop = false) => {
    try {
      // Stop any existing audio first
      stopAudio();
      
      // Create new audio instance
      const audio = new Audio(audioSrc);
      
      // Set loop property before playing
      audio.loop = loop;
      
      // Assign ref BEFORE playing to ensure it can be stopped immediately
      audioRef.current = audio;
      setIsAudioPlaying(true);
      
      // Wait for audio to be ready
      await audio.play();
      
      // Handle audio end
      audio.onended = () => {
        if (!loop) {
          setIsAudioPlaying(false);
        }
      };
      
      // Handle audio errors
      audio.onerror = () => {
        setIsAudioPlaying(false);
      };
      
    } catch (error) {
      setIsAudioPlaying(false);
    }
  };



  // ดึงข้อมูล Solve-Level จาก Database เมื่อเริ่มเกม
  useEffect(() => {
    if (visible && !gameStarted) {
      getCurrentSolveLevel();
    }
  }, [visible, gameStarted]);

  const getCurrentSolveLevel = async () => {
    if (userData?.username) {
      try {
        const userRef = doc(db, "P1", userData.username);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          const userData = docSnap.data();
          const solveLevel = userData.solvelevel || 0;
          setCurrentLevel(solveLevel);
          
          // ตั้งค่าคำถามตามระดับปัจจุบัน
          setCurrentProblem(solveLevel);
        }
      } catch (error) {
        console.error("Error getting Solve-Level:", error);
        setCurrentLevel(0);
        setCurrentProblem(0);
      }
    }
  };

  // แสดง information เมื่อเริ่มต้น
  useEffect(() => {
    if (visible && !gameStarted && currentLevel >= 0 && !infoShown) {
      // เล่นเสียง Solve-Sound.wav แบบวนไปเรื่อยๆ
      playAudio(solveSound, true);
      
      Toast.fire({
        title: '🏆 Sense Maths',
        html: `
          <div style="text-align: left; margin: 20px 0;">
            <h3 style="color: #2c3e50; margin-bottom: 15px; margin-left: 18px;">📋 กติกาการเล่น:</h3>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• ดูภาพโจทย์และหาคำตอบที่ถูกต้อง</p>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• พิมพ์คำตอบในช่องที่กำหนด</p>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• เวลาในการทำ: 120 วินาที</p>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• ตอบถูกจะได้คะแนนตามเวลาที่ใช้ (50-100 คะแนน)</p>
          </div>
        `,
        icon: 'info',
        showCancelButton: false,
        confirmButtonText: '🎮 เริ่มเกม!',
        confirmButtonColor: '#28a745',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false
      }).then(async (result) => {
        if (result.isConfirmed) {
          // หยุดเสียงเมื่อเริ่มเกม
          stopAudio();
          
          setGameStarted(true);
          setTimeLeft(120);
          // เล่นเสียง countdown เมื่อเริ่มเกม
          playAudio(countdownSound);
        }
      });
      
      // Mark info as shown to prevent it from showing again
      setInfoShown(true);
    }
  }, [visible, gameStarted, currentLevel, infoShown]);

  // Timer countdown
  useEffect(() => {
    if (gameStarted && timeLeft > 0 && !gameEnded) {
      const timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (timeLeft === 0 && !gameEnded) {
      // เมื่อเวลาหมด ให้แสดงว่าตอบผิด
      setGameEnded(true);
      playAudio(wrongSound);
      
      Toast.fire({
        title: '⏰ เวลาหมด!',
        html: `
          <div style="text-align: center; margin: 5px 0;">
            <p style="font-size: 18px; color: #e74c3c; margin: 5px 0;">เวลาหมดแล้ว</p>
            <p style="font-size: 20px; font-weight: bold; color: #2c3e50; margin: 5px 0;">คะแนนที่ได้: <span style="color: #e74c3c;">0 คะแนน</span></p>
          </div>
        `,
        icon: 'warning',
        confirmButtonText: 'ตกลง',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false
      }).then(() => {
        // บันทึกคะแนนและออกจากโปรแกรมไปหน้า Exercises
        saveScoreAndNavigate(0, false, 0);
      });
    }
  }, [gameStarted, timeLeft, gameEnded, currentLevel]);

  const handleAnswer = () => {
    // ป้องกันการเรียกซ้ำ
    if (gameEnded) return;
    
    // หยุด timer ทันทีเมื่อตอบคำถาม
    setGameEnded(true);
    
    if (userAnswer.trim() === problemSets[currentProblem].answer) {
      playAudio(trueSound);
      
      
      // Calculate score based on time used
      const timeUsed = 120 - timeLeft;
      let finalScore = 0;
      
      if (timeUsed <= 60) {
        finalScore = 100;
      } else if (timeUsed <= 80) {
        finalScore = 80;
      } else if (timeUsed <= 100) {
        finalScore = 60;
      } else {
        finalScore = 50;
      }
      
      setScore(finalScore);
      
      // ใช้ setTimeout เพื่อให้แน่ใจว่า state ได้อัปเดตแล้ว
      setTimeout(() => {
        Toast.fire({
          title: '🎉 ถูกต้อง!',
          html: `
            <div style="text-align: center; margin: 5px 0;">
              <p style="font-size: 18px; color: #27ae60; margin: 5px 0;">ยินดีด้วย! คุณตอบถูก</p>
              <p style="font-size: 20px; font-weight: bold; color: #2c3e50; margin: 5px 0;">คะแนนที่ได้: <span style="color: #e74c3c;">${finalScore} คะแนน</span></p>
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'ตกลง',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          focusConfirm: true,
          returnFocus: false
        }).then((result) => {
          // บันทึกคะแนนและออกจากโปรแกรมไปหน้า Exercises
          saveScoreAndNavigate(finalScore, true, timeLeft);
        });
      }, 100);
    } else {
      playAudio(wrongSound);
      
      // ใช้ setTimeout เพื่อให้แน่ใจว่า state ได้อัปเดตแล้ว
      setTimeout(() => {
        Toast.fire({
          title: '❌ ผิด!',
          html: `
            <div style="text-align: center; margin: 5px 0;">
              <p style="font-size: 18px; color: #e74c3c; margin: 5px 0;">คำตอบไม่ถูกต้อง</p>
              <p style="font-size: 20px; font-weight: bold; color: #2c3e50; margin: 5px 0;">คะแนนที่ได้: <span style="color: #e74c3c;">0 คะแนน</span></p>
            </div>
          `,
          icon: 'error',
          confirmButtonText: 'ตกลง',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          focusConfirm: true,
          returnFocus: false
        }).then(() => {
          // ออกจากโปรแกรมไปหน้า Exercises
          saveScoreAndNavigate(0, false, timeLeft);
        });
      }, 100);
    }
  };

  const saveScoreAndNavigate = async (finalScore, isCorrect = false, remainingTime = 0) => {
    // console.log("saveScoreAndNavigate called. Score:", finalScore, "User:", userData?.username); // GLOBAL DEBUG
    // บันทึกคะแนนและเพิ่ม Solve-Level
    if (userData?.username) {
      try {
        const userRef = doc(db, "P1", userData.username);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          const currentData = docSnap.data();
          const newScore = (currentData.score || 0) + finalScore;
          
          // 1-2. เพิ่ม solvelevel + 1 ถ้า >= 50 ให้ reset เป็น 0
          let currentSolveLevel = currentData.solvelevel || 0;
          let newSolveLevel = currentSolveLevel + 1;
          if (newSolveLevel >= 50) {
            newSolveLevel = 0;
          }

          // 3. update step4-total (เพิ่มทุกครั้งที่เล่น)
          const newStep4Total = (currentData['step4-total'] || 0) + 1;

          const updateData = {
            score: newScore,
            solvelevel: newSolveLevel,
            'step4-total': newStep4Total
          };

          // 4-5. ถ้าตอบถูก ให้ update step4 และ step4-speed
          if (isCorrect) {
             updateData['step4'] = (currentData['step4'] || 0) + 1;

             const currentSpeed = currentData['step4-speed'] || 0;
             // คำนวณ speed score จากเวลาที่เหลือ (เต็ม 120 วินาที)
             const speedScore = (remainingTime / 120) * 100;

             if (currentSpeed === 0) {
               updateData['step4-speed'] = speedScore;
             } else {
               updateData['step4-speed'] = (currentSpeed + speedScore) / 2;
             }
          }

          await updateDoc(userRef, updateData);
          // console.log("Update successful!", updateData); // DEBUG LOG

          if (onUserUpdate) {
            onUserUpdate(userData.username);
          }
        }
      } catch (error) {
        console.error("Error updating user data:", error);
      }
    }

    // หยุดเสียงก่อนปิดเกม
    stopAudio();
    
    // Reset info shown flag for next time
    setInfoShown(false);
    
    // ปิดเกมและออกจากโปรแกรม
    onClose();
  };

  // Cleanup audio when component unmounts or when closing
  useEffect(() => {
    return () => {
      stopAudio();
    };
  }, []);

  if (!visible) return null;

  if (!gameStarted) return null;

  return (
    <div className="solve-game-modal">
      <div className="solve-game-content">
        <div className="game-header" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
           <h2 style={{ margin: 0 }}>Sense Maths</h2>
           
           <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
             <div style={{
                color: '#333',
                background: '#f0f0f0',
                border: '1px solid #ccc',
                padding: '5px 15px',
                borderRadius: '20px',
                fontWeight: 'bold',
                whiteSpace: 'nowrap'
             }}>
                ⭐ คะแนน: {(() => {
                  const timeUsed = 120 - timeLeft;
                  if (timeUsed <= 60) return 100;
                  if (timeUsed <= 80) return 80;
                  if (timeUsed <= 100) return 60;
                  return 50;
                })()}
             </div>

             <div className="time-display" style={{ 
                color: '#333', 
                background: '#f0f0f0', 
                border: '1px solid #ccc',
                padding: '5px 15px',
                borderRadius: '20px',
                fontWeight: 'bold',
                whiteSpace: 'nowrap'
             }}>
                ⏰ เวลาเหลือ: {timeLeft} วินาที
             </div>
           </div>
        </div>

        <div className="problem-container">
          <div className="problem-image">
            <img 
              src={problemSets[currentProblem].image} 
              alt={`Problem ${currentProblem + 1}`}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>

        <div className="answer-section">
          <div className="input-group">
            <input
              ref={inputRef}
              type="text" 
              inputMode="numeric"
              pattern="[0-9]*"
              value={userAnswer}
              onChange={(e) => {
                const val = e.target.value.replace(/[^0-9]/g, '');
                setUserAnswer(val);
              }}
              placeholder="ใส่คำตอบที่นี่"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && userAnswer.trim() && !gameEnded) {
                  e.preventDefault();
                  e.stopPropagation();
                  handleAnswer();
                }
              }}
              autoFocus
              disabled={gameEnded}
            />
            <button onClick={handleAnswer} disabled={!userAnswer.trim() || gameEnded}>
              ตอบ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SolveGame;